import { render, staticRenderFns } from "./hotarea.vue?vue&type=template&id=b19156ba&scoped=true&"
import script from "./hotarea.vue?vue&type=script&lang=js&"
export * from "./hotarea.vue?vue&type=script&lang=js&"
import style0 from "./hotarea.vue?vue&type=style&index=0&id=b19156ba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19156ba",
  null
  
)

export default component.exports